import React from "react";
import { connect } from 'react-redux';
import { UPDATE_PANEL_SPACINGS } from "../../__editor/panelsEditor/components/panels/panelsActions";
import { metersToInches, round } from "maths";
import { getDetectedModuleSpacing } from "__editor/panelsEditor/components/panels/utils/panelSpacingsUpdate";
import hash from 'object-hash';
import { state } from "__common/store";
import ConfirmationSelectField from '__common/components/ConfirmationSelectField';
import { isRmGridflex10D, isRmGridflex5Rwdi, isRM10Evolution, isSolarMount } from '__common/constants/products';

const precision = 2;

type State = {
  rowSpacingInches: number,
  columnSpacingInches: number,
  detectedRowSpacingInches: number,
  detectedColumnSpacingInches: number,
  productRowSpacingInches: number,
  productColumnSpacingInches: number,
  panelsHash: string,
};

type Props = {
  dispatch: Function,
  productId: number,
  panels: panelInState[],
  stateRowSpacing: number,
  stateColumnSpacing: number,
  metersPerPixel: number,
};

class PanelSpacingUpdator extends React.Component<Props, State> {
  column_spacings = [
    {
      name: '0.25 in',
      type: 0.25,
    },
    {
      name: '0.5 in',
      type: 0.5,
    },
  ];

  constructor(props) {
    super(props);
    let {stateRowSpacing: _rowSpacing,  stateColumnSpacing: _columnSpacing} = this.props;
    [_rowSpacing, _columnSpacing] = [_rowSpacing, _columnSpacing].map(v => round(metersToInches(v), precision));
    this.state = {
      rowSpacingInches: _rowSpacing,
      columnSpacingInches: _columnSpacing,
      detectedRowSpacingInches: _rowSpacing,
      detectedColumnSpacingInches: _columnSpacing,
      productRowSpacingInches:_rowSpacing,
      productColumnSpacingInches: (isRmGridflex10D(this.props.productId) || isRmGridflex5Rwdi(this.props.productId) || isRM10Evolution(this.props.productId)) ? 0.25 : _columnSpacing,
      panelsHash: hash(this.props.panels),
    };
    let {detectedRowSpacingPx, detectedColumnSpacingPx} = getDetectedModuleSpacing(this.props);
    const detectedColumnSpacingInches = round(metersToInches(detectedColumnSpacingPx * this.props.metersPerPixel), precision);
    this.state = {
      ...this.state,
      detectedRowSpacingInches: round(metersToInches(detectedRowSpacingPx * this.props.metersPerPixel), precision),
      detectedColumnSpacingInches: detectedColumnSpacingInches,
      columnSpacingInches: detectedColumnSpacingInches,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.state.panelsHash !== hash(this.props.panels)) {
      const {detectedRowSpacingPx, detectedColumnSpacingPx} = getDetectedModuleSpacing(this.props);
      const detectedColumnSpacingInches = round(metersToInches(detectedColumnSpacingPx * this.props.metersPerPixel), precision);
      this.setState(
        {
          ...this.state,
          detectedRowSpacingInches: round(metersToInches(detectedRowSpacingPx * this.props.metersPerPixel), precision),
          detectedColumnSpacingInches: detectedColumnSpacingInches,
          columnSpacingInches: detectedColumnSpacingInches,
          panelsHash: hash(this.props.panels),
        }
      );
    }
  }

  action() {
    this.props.dispatch(UPDATE_PANEL_SPACINGS(this.state.rowSpacingInches, this.state.columnSpacingInches));
  }

  setVal(property, value) {
    if (isNaN(Number(value))) return;
    this.setState({
      ...this.state, [property]: (value === '' || value === null)? null: Number(value)
    });
  }

  getColumnSpacingLabel = () => {
    return <div className="input-label">Update Column Spacing </div>;
  }

  detectedSpacingsSameAsProductSpacings = () => {
    const { detectedRowSpacingInches, detectedColumnSpacingInches, productRowSpacingInches, productColumnSpacingInches } = this.state;
    return detectedRowSpacingInches === productRowSpacingInches && detectedColumnSpacingInches === productColumnSpacingInches;
  }

  render() {
    const {projectConfiguration:{projectEnvConfig:{is_aurora_project, is_os_project}}} = state();
    if (!this.props.panels.length || isSolarMount(this.props.productId)) return null;
    return (
      <>
        <div className="input-label">Panel Spacings:</div>
        {!this.detectedSpacingsSameAsProductSpacings() &&
        <>
          <p>Product Spec. Row Spacing: {this.state.productRowSpacingInches} in</p>
          <p>Product Spec. Column Spacing: {this.state.productColumnSpacingInches} in</p>
        </>}
        <p>Detected Row Spacing: {this.state.detectedRowSpacingInches} in</p>
        <p>Detected Column Spacing: {this.state.columnSpacingInches} in</p>
        {this.detectedSpacingsSameAsProductSpacings() && <p>(Same as Product Spec. Spacings)</p>}
        {!(is_aurora_project || is_os_project) && (
          <>
            <ConfirmationSelectField
              items={this.column_spacings}
              value={this.state.columnSpacingInches !== null ? this.state.columnSpacingInches : this.state.detectedColumnSpacingInches}
              label={this.getColumnSpacingLabel()}
              onConfirm={(value) => {
                this.setState(
                  {
                    columnSpacingInches: value,
                  },
                  this.action
                );
              }}
              shouldConfirm={false}
              title=""
              content=""
              selectFieldProps={{
                id: 'update-column-spacing',
                itemLabel: 'name',
                itemValue: 'type',
              }}
              key={`col spacing`}
            />
            <p></p>
          </>
        )}
        
      </>
    );
  }
}


function mapStateToProps(state: appState) {
  return {
    productId: state.projectConfiguration.productId,
    stateRowSpacing: state.settings.rowSpacing,
    stateColumnSpacing: state.settings.columnSpacing,
    metersPerPixel: state.background.metersPerPixel,
    panels: state.panels.panels,
  };
}

export default connect(mapStateToProps)(PanelSpacingUpdator);
